<template>
  <router-view/>
</template>

<style lang="scss">
.integral-mdl-tit {
  height: 3.75rem;
  font-size: 1rem;
  width: 18.125rem;
  position: relative;
  img {
    width: 1rem;
    position: absolute;
    right: 0.9375rem;
  }
}
.integral-mdl-name {
  text-align: center;
  font-size: 1rem;
}
.integral-mdl-price {
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin: 0.625rem 0 1.25rem;
  span {
    font-size: 2.375rem;
  }
}
.integral-mdl-type {
  font-size: 0.875rem;
  color: var(--c9);
  padding: 0 0.9375rem;
  height: 2.9375rem;
  border-top: 1px solid var(--ce);
  div {
    color: var(--c3);
    display: flex;
    align-items: center;
    .flex-center {
      width: 1.25rem;
      height: 1.25rem;
      margin-right: .2rem;
    }
  }
}
.integral-mdl-psd {
  height: 2.6875rem;
  margin: 0 0.9375rem;
  border-radius: .5rem;
  width: calc(100% - 1.875rem);
  border: 1px solid var(--ce);
  text-align: center;
}
</style>
